import { alpha, Theme } from "@mui/material/styles";

export const useStyle = (theme: Theme) => ({
  paper: {
    padding: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
    maxWidth: "100%",
  },
  titleAndLinkPage: {
    flexGrow: 1,
    fontWeight: 400,
    fontSize: "1.25rem",
    mt: 1,
    mb: 2,
  },
  boxHeader: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    height: "fit-content",
    justifyContent: "space-between",
    alignItems: { xs: "start", md: "center" },
    gap: { xs: 2, md: 0 },
  },
  boxSearchAndFilter: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    flexDirection: { xs: "column", md: "row" },
    gap: 2,
  },
  button: {
    height: "40px",
  },
  searchInput: {
    width: "325px",
  },
  dataGrid: {
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    minHeight: 500,
    fontSize: 12,
    borderRadius: 0,
    border: 0,
    backgroundColor: "transparent",
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    ".MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
      borderColor: theme.palette.stroke,
    },
    "& .MuiDataGrid-scrollbar--vertical": {
      display: "none",
    },
    "& .MuiDataGrid-filler": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--borderTop": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--header": {
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.stroke}`,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "text.primary", // Altera a cor do titulo do cabeçalho
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "transparent", // Altera cor do rodapé
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      height: "45px",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: theme.palette.background.paper, // Altera cor do cabeçalho
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      // width: "100%",
    },
    "& .MuiDataGrid-topContainer": {
      border: 0,
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiDataGrid-row--borderBottom": {
      border: 0,
    },
    "& .MuiDataGrid-columnHeaders": {
      border: 0,
      height: "55px",
      backgroundColor: theme.palette.background.paper,
    },

    "& .even-row": { backgroundColor: theme.palette.table },
    "& .odd-row": { backgroundColor: theme.palette.background.paper },
  },
  boxRenderCell: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    //height: "100%",
    alignItems: "center",
    gap: 1,
  },
  boxRenderCellIcon: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
  },
  typography: {
    fontSize: "1rem",
    color: theme.palette.text.secondary,
  },
  chip: {
    fontWeight: 500,
    color: theme.palette.background.card,
    backgroundColor: alpha(theme.palette.background.cardInverted, 0.6),
    padding: "0px 8px",
    height: "28px",
    maxWidth: "150px",
  },
  boxData: {
    display: "flex",
    gap: 2,
    alignItems: "center",
  },
  boxDataHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",

    gap: 1,
    height: "40px",
    borderRadius: 1,
    padding: 1,
    border: `1px solid ${theme.palette.text.primary}`,
  },
  boxNoRowsOverlay: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  iconUserNotFound: {
    width: "140px",
    height: "140px",
    fill: theme.palette.text.disabled,
  },
});
